@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-445_067_095)
internal val Res.string.exp_content_aggettivi_plurale_1: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_plurale_1", "exp_content_aggettivi_plurale_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24305, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24777, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25329, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23777, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22417, 119),
      ))
    }

@delegate:ResourceContentHash(-1_318_474_250)
internal val Res.string.exp_content_aggettivi_plurale_10: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_plurale_10", "exp_content_aggettivi_plurale_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24091, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24567, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25115, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23567, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22195, 108),
      ))
    }

@delegate:ResourceContentHash(81_695_646)
internal val Res.string.exp_content_aggettivi_plurale_11: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_plurale_11", "exp_content_aggettivi_plurale_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24200, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24676, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25220, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23676, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22304, 112),
      ))
    }

@delegate:ResourceContentHash(446_258_206)
internal val Res.string.exp_content_aggettivi_plurale_2: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_plurale_2", "exp_content_aggettivi_plurale_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24433, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24889, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25449, 131),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23885, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22537, 115),
      ))
    }

@delegate:ResourceContentHash(-995_045_537)
internal val Res.string.exp_content_aggettivi_plurale_3: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_plurale_3", "exp_content_aggettivi_plurale_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24549, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25013, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25581, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24005, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22653, 87),
      ))
    }

@delegate:ResourceContentHash(-2_079_720_368)
internal val Res.string.exp_content_aggettivi_plurale_4: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_plurale_4", "exp_content_aggettivi_plurale_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24645, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25105, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25669, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24097, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22741, 111),
      ))
    }

@delegate:ResourceContentHash(-101_674_491)
internal val Res.string.exp_content_aggettivi_plurale_5: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_plurale_5", "exp_content_aggettivi_plurale_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24773, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25233, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25789, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24221, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22853, 127),
      ))
    }

@delegate:ResourceContentHash(-2_087_064_131)
internal val Res.string.exp_content_aggettivi_plurale_6: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_plurale_6", "exp_content_aggettivi_plurale_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24905, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25365, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25917, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24349, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22981, 79),
      ))
    }

@delegate:ResourceContentHash(661_152_153)
internal val Res.string.exp_content_aggettivi_plurale_7: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_plurale_7", "exp_content_aggettivi_plurale_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24989, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25453, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26001, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24433, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23061, 71),
      ))
    }

@delegate:ResourceContentHash(-1_650_679_777)
internal val Res.string.exp_content_aggettivi_plurale_8: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_plurale_8", "exp_content_aggettivi_plurale_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25065, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25525, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26073, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24509, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23133, 111),
      ))
    }

@delegate:ResourceContentHash(2_092_475_890)
internal val Res.string.exp_content_aggettivi_plurale_9: StringResource by lazy {
      StringResource("string:exp_content_aggettivi_plurale_9", "exp_content_aggettivi_plurale_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25181, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25645, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26197, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24629, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23245, 79),
      ))
    }

@delegate:ResourceContentHash(1_934_509_219)
internal val Res.string.exp_content_aggettivo_sostantivato_1: StringResource by lazy {
      StringResource("string:exp_content_aggettivo_sostantivato_1", "exp_content_aggettivo_sostantivato_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25261, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25729, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26281, 100),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24709, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23325, 104),
      ))
    }

@delegate:ResourceContentHash(1_109_583_667)
internal val Res.string.exp_content_aggettivo_sostantivato_2: StringResource by lazy {
      StringResource("string:exp_content_aggettivo_sostantivato_2", "exp_content_aggettivo_sostantivato_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25386, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25842, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26382, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24826, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23430, 132),
      ))
    }

@delegate:ResourceContentHash(-645_053_207)
internal val Res.string.exp_content_aggettivo_sostantivato_3: StringResource by lazy {
      StringResource("string:exp_content_aggettivo_sostantivato_3", "exp_content_aggettivo_sostantivato_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25527, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25983, 144),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26515, 128),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24955, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23563, 120),
      ))
    }

@delegate:ResourceContentHash(626_628_496)
internal val Res.string.exp_content_aggettivo_sostantivato_4: StringResource by lazy {
      StringResource("string:exp_content_aggettivo_sostantivato_4", "exp_content_aggettivo_sostantivato_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25660, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26128, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26644, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25088, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23684, 84),
      ))
    }

@delegate:ResourceContentHash(65_532_516)
internal val Res.string.exp_content_aggettivo_sostantivato_5: StringResource by lazy {
      StringResource("string:exp_content_aggettivo_sostantivato_5", "exp_content_aggettivo_sostantivato_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25753, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26225, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26741, 120),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25173, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23769, 116),
      ))
    }

@delegate:ResourceContentHash(1_903_250_049)
internal val Res.string.exp_content_aggettivo_sostantivato_6: StringResource by lazy {
      StringResource("string:exp_content_aggettivo_sostantivato_6", "exp_content_aggettivo_sostantivato_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25882, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26342, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26862, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25298, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23886, 124),
      ))
    }

@delegate:ResourceContentHash(289_374_530)
internal val Res.string.exp_content_aggettivo_sostantivato_7: StringResource by lazy {
      StringResource("string:exp_content_aggettivo_sostantivato_7", "exp_content_aggettivo_sostantivato_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25987, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26463, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26979, 128),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25423, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24011, 136),
      ))
    }

@delegate:ResourceContentHash(1_583_273_330)
internal val Res.string.exp_content_aggettivo_sostantivato_8: StringResource by lazy {
      StringResource("string:exp_content_aggettivo_sostantivato_8", "exp_content_aggettivo_sostantivato_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26128, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26596, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27108, 88),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25556, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24148, 84),
      ))
    }

@delegate:ResourceContentHash(265_349_604)
internal val Res.string.exp_content_aggettivo_sostantivato_9: StringResource by lazy {
      StringResource("string:exp_content_aggettivo_sostantivato_9", "exp_content_aggettivo_sostantivato_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26209, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26677, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27197, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25641, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24233, 116),
      ))
    }

@delegate:ResourceContentHash(37_332_609)
internal val Res.string.exp_content_ah_giusto_l_anticipazione_di_rispetto: StringResource by lazy {
      StringResource("string:exp_content_ah_giusto_l_anticipazione_di_rispetto", "exp_content_ah_giusto_l_anticipazione_di_rispetto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26342, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26810, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27334, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25774, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24350, 109),
      ))
    }

@delegate:ResourceContentHash(474_595_766)
internal val Res.string.exp_content_alcuni_simboli_possono_essere_usati_anche_com: StringResource by
    lazy {
      StringResource("string:exp_content_alcuni_simboli_possono_essere_usati_anche_com", "exp_content_alcuni_simboli_possono_essere_usati_anche_com", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26452, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26932, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27456, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25888, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24460, 125),
      ))
    }

@delegate:ResourceContentHash(-718_759_119)
internal val Res.string.exp_content_all_inizio_troviamo_re_dell_alto_e_basso_egitto: StringResource
    by lazy {
      StringResource("string:exp_content_all_inizio_troviamo_re_dell_alto_e_basso_egitto", "exp_content_all_inizio_troviamo_re_dell_alto_e_basso_egitto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26598, 147),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27078, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27614, 151),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26034, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24586, 143),
      ))
    }

@delegate:ResourceContentHash(-1_420_116_173)
internal val Res.string.exp_content_andiamo: StringResource by lazy {
      StringResource("string:exp_content_andiamo", "exp_content_andiamo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26746, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27218, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27766, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26170, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24730, 43),
      ))
    }

@delegate:ResourceContentHash(-1_731_770_268)
internal val Res.string.exp_content_bisogna_usare_il_contesto_chiediti_n_n_ha_sen: StringResource by
    lazy {
      StringResource("string:exp_content_bisogna_usare_il_contesto_chiediti_n_n_ha_sen", "exp_content_bisogna_usare_il_contesto_chiediti_n_n_ha_sen", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26790, 197),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27262, 197),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27814, 221),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26210, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24774, 201),
      ))
    }

@delegate:ResourceContentHash(-285_119_817)
internal val Res.string.exp_content_cambio_di_rotta_1: StringResource by lazy {
      StringResource("string:exp_content_cambio_di_rotta_1", "exp_content_cambio_di_rotta_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 26988, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27460, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28036, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26392, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24976, 113),
      ))
    }

@delegate:ResourceContentHash(-309_095_624)
internal val Res.string.exp_content_cambio_di_rotta_2: StringResource by lazy {
      StringResource("string:exp_content_cambio_di_rotta_2", "exp_content_cambio_di_rotta_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27122, 185),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27586, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28174, 165),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26510, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25090, 145),
      ))
    }

@delegate:ResourceContentHash(-1_589_474_038)
internal val Res.string.exp_content_cambio_di_rotta_3: StringResource by lazy {
      StringResource("string:exp_content_cambio_di_rotta_3", "exp_content_cambio_di_rotta_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27308, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27744, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28340, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26676, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25236, 137),
      ))
    }

@delegate:ResourceContentHash(-2_046_307_367)
internal val Res.string.exp_content_cambio_di_rotta_4: StringResource by lazy {
      StringResource("string:exp_content_cambio_di_rotta_4", "exp_content_cambio_di_rotta_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27454, 213),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27890, 197),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28494, 213),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26814, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25374, 193),
      ))
    }

@delegate:ResourceContentHash(-1_815_252_640)
internal val Res.string.exp_content_cambio_di_rotta_5: StringResource by lazy {
      StringResource("string:exp_content_cambio_di_rotta_5", "exp_content_cambio_di_rotta_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27668, 225),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28088, 221),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28708, 221),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27016, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25568, 205),
      ))
    }

@delegate:ResourceContentHash(-457_173_061)
internal val Res.string.exp_content_cambio_di_rotta_6: StringResource by lazy {
      StringResource("string:exp_content_cambio_di_rotta_6", "exp_content_cambio_di_rotta_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 27894, 121),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28310, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28930, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27218, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25774, 129),
      ))
    }

@delegate:ResourceContentHash(1_284_007_411)
internal val Res.string.exp_content_cambio_di_rotta_7: StringResource by lazy {
      StringResource("string:exp_content_cambio_di_rotta_7", "exp_content_cambio_di_rotta_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28016, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28436, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29052, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27324, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25904, 121),
      ))
    }

@delegate:ResourceContentHash(-1_338_520_333)
internal val Res.string.exp_content_cambio_di_rotta_8: StringResource by lazy {
      StringResource("string:exp_content_cambio_di_rotta_8", "exp_content_cambio_di_rotta_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28142, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28554, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29186, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27430, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26026, 129),
      ))
    }

@delegate:ResourceContentHash(1_646_394_856)
internal val Res.string.exp_content_cambio_di_rotta_9: StringResource by lazy {
      StringResource("string:exp_content_cambio_di_rotta_9", "exp_content_cambio_di_rotta_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28284, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28660, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29312, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27544, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26156, 105),
      ))
    }

@delegate:ResourceContentHash(274_134_225)
internal val Res.string.exp_content_chap5_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_chap5_alyn_1", "exp_content_chap5_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28394, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28762, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29418, 100),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27642, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26262, 104),
      ))
    }

@delegate:ResourceContentHash(659_452_289)
internal val Res.string.exp_content_chap5_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_chap5_alyn_2", "exp_content_chap5_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28495, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28875, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29519, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27747, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26367, 72),
      ))
    }

@delegate:ResourceContentHash(-2_116_374_831)
internal val Res.string.exp_content_chap5_alyn_verbs_2: StringResource by lazy {
      StringResource("string:exp_content_chap5_alyn_verbs_2", "exp_content_chap5_alyn_verbs_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28572, 202),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28964, 166),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29600, 178),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27828, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26440, 170),
      ))
    }

@delegate:ResourceContentHash(312_978_127)
internal val Res.string.exp_content_chap5_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_chap5_nilo_1", "exp_content_chap5_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28775, 208),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29131, 176),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29779, 176),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28007, 180),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26611, 188),
      ))
    }

@delegate:ResourceContentHash(-1_910_869_209)
internal val Res.string.exp_content_chap5_nilo_2: StringResource by lazy {
      StringResource("string:exp_content_chap5_nilo_2", "exp_content_chap5_nilo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 28984, 200),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29308, 184),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29956, 192),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28188, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26800, 184),
      ))
    }

@delegate:ResourceContentHash(1_837_951_266)
internal val Res.string.exp_content_chap5_nilo_3: StringResource by lazy {
      StringResource("string:exp_content_chap5_nilo_3", "exp_content_chap5_nilo_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29185, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29493, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30149, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28361, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26985, 96),
      ))
    }

@delegate:ResourceContentHash(-1_414_544_161)
internal val Res.string.exp_content_che_confusione: StringResource by lazy {
      StringResource("string:exp_content_che_confusione", "exp_content_che_confusione", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29298, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29590, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30254, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28454, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27082, 50),
      ))
    }

@delegate:ResourceContentHash(820_532_653)
internal val Res.string.exp_content_chiss_cosa_significa_l_intera_scritta: StringResource by lazy {
      StringResource("string:exp_content_chiss_cosa_significa_l_intera_scritta", "exp_content_chiss_cosa_significa_l_intera_scritta", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29369, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29649, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30313, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28509, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27133, 113),
      ))
    }

@delegate:ResourceContentHash(1_615_925_191)
internal val Res.string.exp_content_ci_siamo_abbiamo_completato_la_nostra_prima_e: StringResource by
    lazy {
      StringResource("string:exp_content_ci_siamo_abbiamo_completato_la_nostra_prima_e", "exp_content_ci_siamo_abbiamo_completato_la_nostra_prima_e", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29487, 161),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29775, 165),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30439, 173),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28623, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27247, 153),
      ))
    }

@delegate:ResourceContentHash(-845_995_529)
internal val Res.string.exp_content_classi_verbali_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_alyn_1", "exp_content_classi_verbali_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29649, 185),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29941, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30613, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28785, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27401, 161),
      ))
    }

@delegate:ResourceContentHash(1_050_966_079)
internal val Res.string.exp_content_classi_verbali_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_alyn_2", "exp_content_classi_verbali_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29835, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30099, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30771, 141),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28947, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27563, 121),
      ))
    }

@delegate:ResourceContentHash(1_551_286_728)
internal val Res.string.exp_content_classi_verbali_alyn_3: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_alyn_3", "exp_content_classi_verbali_alyn_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 29969, 169),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30249, 185),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30913, 193),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29081, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27685, 169),
      ))
    }

@delegate:ResourceContentHash(344_711_882)
internal val Res.string.exp_content_classi_verbali_alyn_4: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_alyn_4", "exp_content_classi_verbali_alyn_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30139, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30435, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31107, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29263, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27855, 133),
      ))
    }

@delegate:ResourceContentHash(-2_038_683_897)
internal val Res.string.exp_content_classi_verbali_alyn_5: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_alyn_5", "exp_content_classi_verbali_alyn_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30281, 161),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30561, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31241, 161),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29397, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27989, 161),
      ))
    }

@delegate:ResourceContentHash(-320_815_766)
internal val Res.string.exp_content_classi_verbali_alyn_6: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_alyn_6", "exp_content_classi_verbali_alyn_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30443, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30723, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31403, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29563, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28151, 77),
      ))
    }

@delegate:ResourceContentHash(1_616_248_009)
internal val Res.string.exp_content_classi_verbali_alyn_7: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_alyn_7", "exp_content_classi_verbali_alyn_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30529, 221),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30797, 201),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31481, 213),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29633, 193),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28229, 185),
      ))
    }

@delegate:ResourceContentHash(-1_733_288_571)
internal val Res.string.exp_content_classi_verbali_alyn_8: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_alyn_8", "exp_content_classi_verbali_alyn_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30751, 233),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30999, 241),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31695, 249),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29827, 229),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28415, 213),
      ))
    }

@delegate:ResourceContentHash(1_526_098_484)
internal val Res.string.exp_content_classi_verbali_alyn_9: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_alyn_9", "exp_content_classi_verbali_alyn_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 30985, 197),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31241, 205),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31945, 197),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30057, 189),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28629, 193),
      ))
    }

@delegate:ResourceContentHash(-574_088_520)
internal val Res.string.exp_content_classi_verbali_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_nilo_1", "exp_content_classi_verbali_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31183, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31447, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32143, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30247, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28823, 133),
      ))
    }

@delegate:ResourceContentHash(1_825_952_175)
internal val Res.string.exp_content_classi_verbali_nilo_2: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_nilo_2", "exp_content_classi_verbali_nilo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31333, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31589, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32293, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30377, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28957, 141),
      ))
    }

@delegate:ResourceContentHash(-1_779_634_515)
internal val Res.string.exp_content_classi_verbali_zeta_1: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_zeta_1", "exp_content_classi_verbali_zeta_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31475, 285),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31715, 289),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32451, 293),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30511, 265),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29099, 261),
      ))
    }

@delegate:ResourceContentHash(1_158_412_754)
internal val Res.string.exp_content_classi_verbali_zeta_2: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_zeta_2", "exp_content_classi_verbali_zeta_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31761, 161),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32005, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32745, 185),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30777, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29361, 161),
      ))
    }

@delegate:ResourceContentHash(-307_987_682)
internal val Res.string.exp_content_classi_verbali_zeta_3: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_zeta_3", "exp_content_classi_verbali_zeta_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31923, 357),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32155, 349),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32931, 361),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30935, 349),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29523, 337),
      ))
    }

@delegate:ResourceContentHash(-1_450_430_422)
internal val Res.string.exp_content_classi_verbali_zeta_4: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_zeta_4", "exp_content_classi_verbali_zeta_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32281, 325),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32505, 293),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33293, 317),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31285, 293),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29861, 289),
      ))
    }

@delegate:ResourceContentHash(1_686_618_456)
internal val Res.string.exp_content_classi_verbali_zeta_5: StringResource by lazy {
      StringResource("string:exp_content_classi_verbali_zeta_5", "exp_content_classi_verbali_zeta_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32607, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32799, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33611, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31579, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30151, 69),
      ))
    }

@delegate:ResourceContentHash(268_377_223)
internal val Res.string.exp_content_com_possibile: StringResource by lazy {
      StringResource("string:exp_content_com_possibile", "exp_content_com_possibile", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32681, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32881, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33681, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31653, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30221, 65),
      ))
    }

@delegate:ResourceContentHash(-1_146_106_896)
internal val Res.string.exp_content_come_facciamo_a_distinguere_un_caso_dall_altro: StringResource
    by lazy {
      StringResource("string:exp_content_come_facciamo_a_distinguere_un_caso_dall_altro", "exp_content_come_facciamo_a_distinguere_un_caso_dall_altro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32743, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32947, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33751, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31711, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30287, 118),
      ))
    }

@delegate:ResourceContentHash(215_679_962)
internal val Res.string.exp_content_come_in_italiano_i_nomi_si_declinano_per_gene: StringResource by
    lazy {
      StringResource("string:exp_content_come_in_italiano_i_nomi_si_declinano_per_gene", "exp_content_come_in_italiano_i_nomi_si_declinano_per_gene", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32874, 161),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33086, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33870, 141),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31842, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30406, 141),
      ))
    }

@delegate:ResourceContentHash(-1_342_681_872)
internal val Res.string.exp_content_come_sappiamo_i_geroglifici_si_leggono_nella_: StringResource by
    lazy {
      StringResource("string:exp_content_come_sappiamo_i_geroglifici_si_leggono_nella_", "exp_content_come_sappiamo_i_geroglifici_si_leggono_nella_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 33036, 197),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33244, 197),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34012, 201),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31992, 193),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30548, 181),
      ))
    }

@delegate:ResourceContentHash(-78_624_329)
internal val Res.string.exp_content_come_vedi_il_genitivo_diretto_facilissimo_da_: StringResource by
    lazy {
      StringResource("string:exp_content_come_vedi_il_genitivo_diretto_facilissimo_da_", "exp_content_come_vedi_il_genitivo_diretto_facilissimo_da_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 33234, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33442, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34214, 165),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32186, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30730, 149),
      ))
    }

@delegate:ResourceContentHash(-433_291_222)
internal val Res.string.exp_content_complementi_complessi_1: StringResource by lazy {
      StringResource("string:exp_content_complementi_complessi_1", "exp_content_complementi_complessi_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 33457, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33653, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34453, 135),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32401, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30949, 99),
      ))
    }

@delegate:ResourceContentHash(-1_875_571_555)
internal val Res.string.exp_content_complementi_complessi_10: StringResource by lazy {
      StringResource("string:exp_content_complementi_complessi_10", "exp_content_complementi_complessi_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 33384, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33584, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34380, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32332, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30880, 68),
      ))
    }

@delegate:ResourceContentHash(-116_568_920)
internal val Res.string.exp_content_complementi_complessi_2: StringResource by lazy {
      StringResource("string:exp_content_complementi_complessi_2", "exp_content_complementi_complessi_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 33589, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33781, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34589, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32513, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31049, 51),
      ))
    }

@delegate:ResourceContentHash(-1_771_339_556)
internal val Res.string.exp_content_complementi_complessi_3: StringResource by lazy {
      StringResource("string:exp_content_complementi_complessi_3", "exp_content_complementi_complessi_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 33645, 143),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33837, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34645, 155),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32565, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31101, 127),
      ))
    }

@delegate:ResourceContentHash(-3_842_075)
internal val Res.string.exp_content_complementi_complessi_4: StringResource by lazy {
      StringResource("string:exp_content_complementi_complessi_4", "exp_content_complementi_complessi_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 33789, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33969, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34801, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32697, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31229, 99),
      ))
    }

@delegate:ResourceContentHash(-1_741_967_713)
internal val Res.string.exp_content_complementi_complessi_5: StringResource by lazy {
      StringResource("string:exp_content_complementi_complessi_5", "exp_content_complementi_complessi_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 33893, 199),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34065, 159),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34901, 179),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32785, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31329, 163),
      ))
    }

@delegate:ResourceContentHash(2_006_923_471)
internal val Res.string.exp_content_complementi_complessi_6: StringResource by lazy {
      StringResource("string:exp_content_complementi_complessi_6", "exp_content_complementi_complessi_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 34093, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34225, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35081, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32949, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31493, 51),
      ))
    }

@delegate:ResourceContentHash(786_848_582)
internal val Res.string.exp_content_complementi_complessi_7: StringResource by lazy {
      StringResource("string:exp_content_complementi_complessi_7", "exp_content_complementi_complessi_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 34149, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34281, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35137, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33001, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31545, 115),
      ))
    }

@delegate:ResourceContentHash(-1_226_537_709)
internal val Res.string.exp_content_complementi_complessi_8: StringResource by lazy {
      StringResource("string:exp_content_complementi_complessi_8", "exp_content_complementi_complessi_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 34273, 179),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34417, 203),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35265, 207),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33133, 187),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31661, 167),
      ))
    }

@delegate:ResourceContentHash(-1_310_325_118)
internal val Res.string.exp_content_complementi_complessi_9: StringResource by lazy {
      StringResource("string:exp_content_complementi_complessi_9", "exp_content_complementi_complessi_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 34453, 171),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34621, 179),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35473, 175),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33321, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31829, 155),
      ))
    }

@delegate:ResourceContentHash(325_495_013)
internal val Res.string.exp_content_complemento_oggetto_1: StringResource by lazy {
      StringResource("string:exp_content_complemento_oggetto_1", "exp_content_complemento_oggetto_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 34625, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34801, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35649, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33493, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31985, 57),
      ))
    }

@delegate:ResourceContentHash(463_326_267)
internal val Res.string.exp_content_complemento_oggetto_2: StringResource by lazy {
      StringResource("string:exp_content_complemento_oggetto_2", "exp_content_complemento_oggetto_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 34679, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34859, 133),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35707, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33551, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32043, 141),
      ))
    }

@delegate:ResourceContentHash(1_279_464_885)
internal val Res.string.exp_content_complemento_oggetto_3: StringResource by lazy {
      StringResource("string:exp_content_complemento_oggetto_3", "exp_content_complemento_oggetto_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 34845, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34993, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35853, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33697, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32185, 65),
      ))
    }

@delegate:ResourceContentHash(-1_171_631_492)
internal val Res.string.exp_content_complemento_oggetto_4: StringResource by lazy {
      StringResource("string:exp_content_complemento_oggetto_4", "exp_content_complemento_oggetto_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 34915, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35071, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35919, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33771, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32251, 125),
      ))
    }

@delegate:ResourceContentHash(94_889_441)
internal val Res.string.exp_content_complemento_oggetto_5: StringResource by lazy {
      StringResource("string:exp_content_complemento_oggetto_5", "exp_content_complemento_oggetto_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 35041, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35201, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36057, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33893, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32377, 81),
      ))
    }

@delegate:ResourceContentHash(-442_213_833)
internal val Res.string.exp_content_complemento_oggetto_6: StringResource by lazy {
      StringResource("string:exp_content_complemento_oggetto_6", "exp_content_complemento_oggetto_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 35119, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35279, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36143, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33971, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32459, 109),
      ))
    }

@delegate:ResourceContentHash(-262_645_943)
internal val Res.string.exp_content_complemento_oggetto_7: StringResource by lazy {
      StringResource("string:exp_content_complemento_oggetto_7", "exp_content_complemento_oggetto_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 35233, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35389, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36249, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34081, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32569, 53),
      ))
    }

@delegate:ResourceContentHash(1_375_972_264)
internal val Res.string.exp_content_complemento_oggetto_8: StringResource by lazy {
      StringResource("string:exp_content_complemento_oggetto_8", "exp_content_complemento_oggetto_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 35283, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35443, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36307, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34135, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32623, 57),
      ))
    }

@delegate:ResourceContentHash(303_433_661)
internal val Res.string.exp_content_comunque_la_cosa_strana_un_altra: StringResource by lazy {
      StringResource("string:exp_content_comunque_la_cosa_strana_un_altra", "exp_content_comunque_la_cosa_strana_un_altra", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 35341, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35501, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36369, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34193, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32681, 108),
      ))
    }

@delegate:ResourceContentHash(120_360_378)
internal val Res.string.exp_content_continuiamo_con_esercizi_sul_genitivo_diretto: StringResource by
    lazy {
      StringResource("string:exp_content_continuiamo_con_esercizi_sul_genitivo_diretto", "exp_content_continuiamo_con_esercizi_sul_genitivo_diretto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 35450, 137),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35614, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36486, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34298, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32790, 137),
      ))
    }

@delegate:ResourceContentHash(-1_285_122_264)
internal val Res.string.exp_content_dei_sovrani_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_dei_sovrani_nilo_1", "exp_content_dei_sovrani_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 35588, 114),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35756, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36624, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34428, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32928, 106),
      ))
    }

@delegate:ResourceContentHash(-7_244_018)
internal val Res.string.exp_content_dei_sovrani_zeta_1: StringResource by lazy {
      StringResource("string:exp_content_dei_sovrani_zeta_1", "exp_content_dei_sovrani_zeta_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 35703, 90),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35871, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36743, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34531, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33035, 90),
      ))
    }

@delegate:ResourceContentHash(963_857_295)
internal val Res.string.exp_content_di_norma_un_sostantivo_maschile_se_non_termin: StringResource by
    lazy {
      StringResource("string:exp_content_di_norma_un_sostantivo_maschile_se_non_termin", "exp_content_di_norma_un_sostantivo_maschile_se_non_termin", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 35794, 177),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35962, 169),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36834, 181),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34622, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33126, 165),
      ))
    }

@delegate:ResourceContentHash(1_234_232_059)
internal val Res.string.exp_content_dobbiamo_subito_scoprire_cosa_significa: StringResource by
    lazy {
      StringResource("string:exp_content_dobbiamo_subito_scoprire_cosa_significa", "exp_content_dobbiamo_subito_scoprire_cosa_significa", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 35972, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36132, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37016, 139),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34784, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33292, 119),
      ))
    }

@delegate:ResourceContentHash(-443_771_331)
internal val Res.string.exp_content_due_oggetti_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_due_oggetti_alyn_1", "exp_content_due_oggetti_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 36100, 118),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36256, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37156, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34900, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33412, 118),
      ))
    }

@delegate:ResourceContentHash(-829_695_528)
internal val Res.string.exp_content_due_oggetti_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_due_oggetti_alyn_2", "exp_content_due_oggetti_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 36219, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36379, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37287, 114),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35031, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33531, 110),
      ))
    }

@delegate:ResourceContentHash(1_979_743_739)
internal val Res.string.exp_content_due_oggetti_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_due_oggetti_nilo_1", "exp_content_due_oggetti_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 36346, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36498, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37402, 94),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35142, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33642, 82),
      ))
    }

@delegate:ResourceContentHash(-1_996_262_943)
internal val Res.string.exp_content_due_oggetti_nilo_2: StringResource by lazy {
      StringResource("string:exp_content_due_oggetti_nilo_2", "exp_content_due_oggetti_nilo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 36449, 134),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36593, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37497, 134),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35233, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33725, 118),
      ))
    }

@delegate:ResourceContentHash(586_043_488)
internal val Res.string.exp_content_due_soggetti_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_due_soggetti_alyn_1", "exp_content_due_soggetti_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 36584, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36716, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37632, 131),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35348, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33844, 127),
      ))
    }

@delegate:ResourceContentHash(-310_622_082)
internal val Res.string.exp_content_due_soggetti_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_due_soggetti_alyn_2", "exp_content_due_soggetti_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 36712, 191),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36832, 171),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37764, 171),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35468, 175),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33972, 175),
      ))
    }

@delegate:ResourceContentHash(12_291_870)
internal val Res.string.exp_content_due_soggetti_alyn_3: StringResource by lazy {
      StringResource("string:exp_content_due_soggetti_alyn_3", "exp_content_due_soggetti_alyn_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 36904, 183),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37004, 211),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37936, 175),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35644, 187),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34148, 167),
      ))
    }

@delegate:ResourceContentHash(819_240_850)
internal val Res.string.exp_content_due_soggetti_alyn_4: StringResource by lazy {
      StringResource("string:exp_content_due_soggetti_alyn_4", "exp_content_due_soggetti_alyn_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 37088, 159),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37216, 151),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38112, 151),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35832, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34316, 135),
      ))
    }

@delegate:ResourceContentHash(-222_072_662)
internal val Res.string.exp_content_due_soggetti_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_due_soggetti_nilo_1", "exp_content_due_soggetti_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 37248, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37368, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38264, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35976, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34452, 91),
      ))
    }

@delegate:ResourceContentHash(-1_411_799_298)
internal val Res.string.exp_content_due_soggetti_nilo_2: StringResource by lazy {
      StringResource("string:exp_content_due_soggetti_nilo_2", "exp_content_due_soggetti_nilo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 37324, 139),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37464, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38364, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36072, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34544, 111),
      ))
    }

@delegate:ResourceContentHash(-1_297_767_473)
internal val Res.string.exp_content_due_soggetti_nilo_3: StringResource by lazy {
      StringResource("string:exp_content_due_soggetti_nilo_3", "exp_content_due_soggetti_nilo_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 37464, 263),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37592, 239),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38484, 251),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36196, 231),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34656, 223),
      ))
    }

@delegate:ResourceContentHash(294_587_451)
internal val Res.string.exp_content_due_soggetti_nilo_4: StringResource by lazy {
      StringResource("string:exp_content_due_soggetti_nilo_4", "exp_content_due_soggetti_nilo_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 37728, 267),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37832, 263),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38736, 267),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36428, 263),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34880, 239),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("exp_content_aggettivi_plurale_1", Res.string.exp_content_aggettivi_plurale_1)
  map.put("exp_content_aggettivi_plurale_10", Res.string.exp_content_aggettivi_plurale_10)
  map.put("exp_content_aggettivi_plurale_11", Res.string.exp_content_aggettivi_plurale_11)
  map.put("exp_content_aggettivi_plurale_2", Res.string.exp_content_aggettivi_plurale_2)
  map.put("exp_content_aggettivi_plurale_3", Res.string.exp_content_aggettivi_plurale_3)
  map.put("exp_content_aggettivi_plurale_4", Res.string.exp_content_aggettivi_plurale_4)
  map.put("exp_content_aggettivi_plurale_5", Res.string.exp_content_aggettivi_plurale_5)
  map.put("exp_content_aggettivi_plurale_6", Res.string.exp_content_aggettivi_plurale_6)
  map.put("exp_content_aggettivi_plurale_7", Res.string.exp_content_aggettivi_plurale_7)
  map.put("exp_content_aggettivi_plurale_8", Res.string.exp_content_aggettivi_plurale_8)
  map.put("exp_content_aggettivi_plurale_9", Res.string.exp_content_aggettivi_plurale_9)
  map.put("exp_content_aggettivo_sostantivato_1", Res.string.exp_content_aggettivo_sostantivato_1)
  map.put("exp_content_aggettivo_sostantivato_2", Res.string.exp_content_aggettivo_sostantivato_2)
  map.put("exp_content_aggettivo_sostantivato_3", Res.string.exp_content_aggettivo_sostantivato_3)
  map.put("exp_content_aggettivo_sostantivato_4", Res.string.exp_content_aggettivo_sostantivato_4)
  map.put("exp_content_aggettivo_sostantivato_5", Res.string.exp_content_aggettivo_sostantivato_5)
  map.put("exp_content_aggettivo_sostantivato_6", Res.string.exp_content_aggettivo_sostantivato_6)
  map.put("exp_content_aggettivo_sostantivato_7", Res.string.exp_content_aggettivo_sostantivato_7)
  map.put("exp_content_aggettivo_sostantivato_8", Res.string.exp_content_aggettivo_sostantivato_8)
  map.put("exp_content_aggettivo_sostantivato_9", Res.string.exp_content_aggettivo_sostantivato_9)
  map.put("exp_content_ah_giusto_l_anticipazione_di_rispetto", Res.string.exp_content_ah_giusto_l_anticipazione_di_rispetto)
  map.put("exp_content_alcuni_simboli_possono_essere_usati_anche_com", Res.string.exp_content_alcuni_simboli_possono_essere_usati_anche_com)
  map.put("exp_content_all_inizio_troviamo_re_dell_alto_e_basso_egitto", Res.string.exp_content_all_inizio_troviamo_re_dell_alto_e_basso_egitto)
  map.put("exp_content_andiamo", Res.string.exp_content_andiamo)
  map.put("exp_content_bisogna_usare_il_contesto_chiediti_n_n_ha_sen", Res.string.exp_content_bisogna_usare_il_contesto_chiediti_n_n_ha_sen)
  map.put("exp_content_cambio_di_rotta_1", Res.string.exp_content_cambio_di_rotta_1)
  map.put("exp_content_cambio_di_rotta_2", Res.string.exp_content_cambio_di_rotta_2)
  map.put("exp_content_cambio_di_rotta_3", Res.string.exp_content_cambio_di_rotta_3)
  map.put("exp_content_cambio_di_rotta_4", Res.string.exp_content_cambio_di_rotta_4)
  map.put("exp_content_cambio_di_rotta_5", Res.string.exp_content_cambio_di_rotta_5)
  map.put("exp_content_cambio_di_rotta_6", Res.string.exp_content_cambio_di_rotta_6)
  map.put("exp_content_cambio_di_rotta_7", Res.string.exp_content_cambio_di_rotta_7)
  map.put("exp_content_cambio_di_rotta_8", Res.string.exp_content_cambio_di_rotta_8)
  map.put("exp_content_cambio_di_rotta_9", Res.string.exp_content_cambio_di_rotta_9)
  map.put("exp_content_chap5_alyn_1", Res.string.exp_content_chap5_alyn_1)
  map.put("exp_content_chap5_alyn_2", Res.string.exp_content_chap5_alyn_2)
  map.put("exp_content_chap5_alyn_verbs_2", Res.string.exp_content_chap5_alyn_verbs_2)
  map.put("exp_content_chap5_nilo_1", Res.string.exp_content_chap5_nilo_1)
  map.put("exp_content_chap5_nilo_2", Res.string.exp_content_chap5_nilo_2)
  map.put("exp_content_chap5_nilo_3", Res.string.exp_content_chap5_nilo_3)
  map.put("exp_content_che_confusione", Res.string.exp_content_che_confusione)
  map.put("exp_content_chiss_cosa_significa_l_intera_scritta", Res.string.exp_content_chiss_cosa_significa_l_intera_scritta)
  map.put("exp_content_ci_siamo_abbiamo_completato_la_nostra_prima_e", Res.string.exp_content_ci_siamo_abbiamo_completato_la_nostra_prima_e)
  map.put("exp_content_classi_verbali_alyn_1", Res.string.exp_content_classi_verbali_alyn_1)
  map.put("exp_content_classi_verbali_alyn_2", Res.string.exp_content_classi_verbali_alyn_2)
  map.put("exp_content_classi_verbali_alyn_3", Res.string.exp_content_classi_verbali_alyn_3)
  map.put("exp_content_classi_verbali_alyn_4", Res.string.exp_content_classi_verbali_alyn_4)
  map.put("exp_content_classi_verbali_alyn_5", Res.string.exp_content_classi_verbali_alyn_5)
  map.put("exp_content_classi_verbali_alyn_6", Res.string.exp_content_classi_verbali_alyn_6)
  map.put("exp_content_classi_verbali_alyn_7", Res.string.exp_content_classi_verbali_alyn_7)
  map.put("exp_content_classi_verbali_alyn_8", Res.string.exp_content_classi_verbali_alyn_8)
  map.put("exp_content_classi_verbali_alyn_9", Res.string.exp_content_classi_verbali_alyn_9)
  map.put("exp_content_classi_verbali_nilo_1", Res.string.exp_content_classi_verbali_nilo_1)
  map.put("exp_content_classi_verbali_nilo_2", Res.string.exp_content_classi_verbali_nilo_2)
  map.put("exp_content_classi_verbali_zeta_1", Res.string.exp_content_classi_verbali_zeta_1)
  map.put("exp_content_classi_verbali_zeta_2", Res.string.exp_content_classi_verbali_zeta_2)
  map.put("exp_content_classi_verbali_zeta_3", Res.string.exp_content_classi_verbali_zeta_3)
  map.put("exp_content_classi_verbali_zeta_4", Res.string.exp_content_classi_verbali_zeta_4)
  map.put("exp_content_classi_verbali_zeta_5", Res.string.exp_content_classi_verbali_zeta_5)
  map.put("exp_content_com_possibile", Res.string.exp_content_com_possibile)
  map.put("exp_content_come_facciamo_a_distinguere_un_caso_dall_altro", Res.string.exp_content_come_facciamo_a_distinguere_un_caso_dall_altro)
  map.put("exp_content_come_in_italiano_i_nomi_si_declinano_per_gene", Res.string.exp_content_come_in_italiano_i_nomi_si_declinano_per_gene)
  map.put("exp_content_come_sappiamo_i_geroglifici_si_leggono_nella_", Res.string.exp_content_come_sappiamo_i_geroglifici_si_leggono_nella_)
  map.put("exp_content_come_vedi_il_genitivo_diretto_facilissimo_da_", Res.string.exp_content_come_vedi_il_genitivo_diretto_facilissimo_da_)
  map.put("exp_content_complementi_complessi_1", Res.string.exp_content_complementi_complessi_1)
  map.put("exp_content_complementi_complessi_10", Res.string.exp_content_complementi_complessi_10)
  map.put("exp_content_complementi_complessi_2", Res.string.exp_content_complementi_complessi_2)
  map.put("exp_content_complementi_complessi_3", Res.string.exp_content_complementi_complessi_3)
  map.put("exp_content_complementi_complessi_4", Res.string.exp_content_complementi_complessi_4)
  map.put("exp_content_complementi_complessi_5", Res.string.exp_content_complementi_complessi_5)
  map.put("exp_content_complementi_complessi_6", Res.string.exp_content_complementi_complessi_6)
  map.put("exp_content_complementi_complessi_7", Res.string.exp_content_complementi_complessi_7)
  map.put("exp_content_complementi_complessi_8", Res.string.exp_content_complementi_complessi_8)
  map.put("exp_content_complementi_complessi_9", Res.string.exp_content_complementi_complessi_9)
  map.put("exp_content_complemento_oggetto_1", Res.string.exp_content_complemento_oggetto_1)
  map.put("exp_content_complemento_oggetto_2", Res.string.exp_content_complemento_oggetto_2)
  map.put("exp_content_complemento_oggetto_3", Res.string.exp_content_complemento_oggetto_3)
  map.put("exp_content_complemento_oggetto_4", Res.string.exp_content_complemento_oggetto_4)
  map.put("exp_content_complemento_oggetto_5", Res.string.exp_content_complemento_oggetto_5)
  map.put("exp_content_complemento_oggetto_6", Res.string.exp_content_complemento_oggetto_6)
  map.put("exp_content_complemento_oggetto_7", Res.string.exp_content_complemento_oggetto_7)
  map.put("exp_content_complemento_oggetto_8", Res.string.exp_content_complemento_oggetto_8)
  map.put("exp_content_comunque_la_cosa_strana_un_altra", Res.string.exp_content_comunque_la_cosa_strana_un_altra)
  map.put("exp_content_continuiamo_con_esercizi_sul_genitivo_diretto", Res.string.exp_content_continuiamo_con_esercizi_sul_genitivo_diretto)
  map.put("exp_content_dei_sovrani_nilo_1", Res.string.exp_content_dei_sovrani_nilo_1)
  map.put("exp_content_dei_sovrani_zeta_1", Res.string.exp_content_dei_sovrani_zeta_1)
  map.put("exp_content_di_norma_un_sostantivo_maschile_se_non_termin", Res.string.exp_content_di_norma_un_sostantivo_maschile_se_non_termin)
  map.put("exp_content_dobbiamo_subito_scoprire_cosa_significa", Res.string.exp_content_dobbiamo_subito_scoprire_cosa_significa)
  map.put("exp_content_due_oggetti_alyn_1", Res.string.exp_content_due_oggetti_alyn_1)
  map.put("exp_content_due_oggetti_alyn_2", Res.string.exp_content_due_oggetti_alyn_2)
  map.put("exp_content_due_oggetti_nilo_1", Res.string.exp_content_due_oggetti_nilo_1)
  map.put("exp_content_due_oggetti_nilo_2", Res.string.exp_content_due_oggetti_nilo_2)
  map.put("exp_content_due_soggetti_alyn_1", Res.string.exp_content_due_soggetti_alyn_1)
  map.put("exp_content_due_soggetti_alyn_2", Res.string.exp_content_due_soggetti_alyn_2)
  map.put("exp_content_due_soggetti_alyn_3", Res.string.exp_content_due_soggetti_alyn_3)
  map.put("exp_content_due_soggetti_alyn_4", Res.string.exp_content_due_soggetti_alyn_4)
  map.put("exp_content_due_soggetti_nilo_1", Res.string.exp_content_due_soggetti_nilo_1)
  map.put("exp_content_due_soggetti_nilo_2", Res.string.exp_content_due_soggetti_nilo_2)
  map.put("exp_content_due_soggetti_nilo_3", Res.string.exp_content_due_soggetti_nilo_3)
  map.put("exp_content_due_soggetti_nilo_4", Res.string.exp_content_due_soggetti_nilo_4)
}
